import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

export function PageShell({ children, className = '' }: PageShellProps) {
  return (
    <div className={`relative min-h-screen overflow-hidden bg-ink ${className}`}>
      <div className="pointer-events-none absolute inset-0 app-glow" />
      <div className="pointer-events-none absolute inset-0 stadium-grid opacity-40" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 sm:py-10 lg:px-8">
        {children}
      </div>
    </div>
  );
}
